import React, { useState } from 'react';
import { API_URLS } from '../config/api';
import { apiGet, apiPost, showToast } from '../utils/apiUtils';
import { t } from '../i18n';
import './ReportModal.css';

const ReportModal = ({ onClose, novelId = null, gameStateId = null }) => {
  const [tab, setTab] = useState('send');
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);
  const [myReports, setMyReports] = useState([]);
  const [reportsLoading, setReportsLoading] = useState(false);

  const loadMyReports = async () => {
    setReportsLoading(true);
    try {
      const res = await apiGet(API_URLS.REPORTS_MY);
      setMyReports(res.data);
    } catch (e) {}
    finally { setReportsLoading(false); }
  };

  const handleTabChange = (t) => {
    setTab(t);
    if (t === 'my') loadMyReports();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    try {
      await apiPost(API_URLS.REPORTS_CREATE, {
        text: text.trim(),
        novel_id: novelId,
        game_state_id: gameStateId,
      });
      showToast(t('Сообщение отправлено'), 'success');
      setText('');
      handleTabChange('my');
    } catch (err) {
      showToast(t('Ошибка при отправке'), 'error');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="rm-overlay" onClick={onClose}>
      <div className="rm-modal" onClick={e => e.stopPropagation()}>
        <div className="rm-head">
          <h3 className="rm-title">🚩 {t('Сообщить об ошибке / задать вопрос')}</h3>
          <button className="rm-close" onClick={onClose}>✕</button>
        </div>

        <div className="rm-tabs">
          <button className={`rm-tab${tab === 'send' ? ' active' : ''}`} onClick={() => handleTabChange('send')}>{t('Отправить')}</button>
          <button className={`rm-tab${tab === 'my' ? ' active' : ''}`} onClick={() => handleTabChange('my')}>{t('Мои обращения')}</button>
        </div>

        <div className="rm-body">
          {tab === 'send' ? (
            <form onSubmit={handleSubmit} className="rm-form">
              <p className="rm-hint">{t('Опишите проблему или задайте вопрос — администратор скоро Вам ответит.')}</p>
              <textarea
                className="rm-textarea"
                value={text}
                onChange={e => setText(e.target.value)}
                placeholder={t('Ваше сообщение...')}
                rows={5}
                maxLength={2000}
              />
              <button type="submit" className="rm-submit" disabled={sending || !text.trim()}>
                {sending ? t('Отправка...') : t('Отправить')}
              </button>
            </form>
          ) : (
            <div className="rm-list">
              {reportsLoading ? (
                <p className="rm-empty">{t('Загрузка...')}</p>
              ) : myReports.length === 0 ? (
                <p className="rm-empty">{t('Обращений нет')}</p>
              ) : myReports.map(r => (
                <div key={r.id} className="rm-item">
                  <div className="rm-item-date">{new Date(r.created_at).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</div>
                  <div className="rm-item-text">{r.text}</div>
                  {r.admin_response ? (
                    <div className="rm-item-response">
                      <span className="rm-response-label">{t('Ответ администратора:')}</span>
                      <span>{r.admin_response}</span>
                    </div>
                  ) : (
                    <div className="rm-item-pending">⏳ {t('Администратор скоро Вам ответит')}</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
